import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerFlex: {
        flex: 1,
    },
    containerItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 15,
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    checkboxCircle: {
        width: 10,
        height: 10,
        borderRadius: 5,
        borderWidth: 1.5,
        borderColor: theme.colors.colorPrimary,
        marginRight: 8,
    },
    item: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
})

export default styles
